import * as React from "react";
import { useState } from "react";
import Cookie from "js-cookie";
import { DO_NOT_ASK_ABOUT_REDIRECTING_TO_OCX_COOKIE_NAME } from "../../utils/constants";
import { Button, Checkbox, Classes, Dialog, Intent } from "@blueprintjs/core";
import Timer5s, { TIMER_5S_WRAPPER_CLASSNAME } from "../timer-5s";

export default function RedirectToOCXDialog({ url, onClose }: { url: string; onClose(): void }) {
  const [doNotAsk, setDoNotAsk] = useState<boolean>(false);
  function handleConfirm() {
    if (doNotAsk) {
      Cookie.set(DO_NOT_ASK_ABOUT_REDIRECTING_TO_OCX_COOKIE_NAME, "true");
    }
    window.location.href = url;
  }

  return (
    <Dialog
      icon="info-sign"
      isOpen={true}
      usePortal={true}
      title="You're being taken to One Codex"
      onClose={onClose}
    >
      <div className={Classes.DIALOG_BODY}>
        <p>
          ATCC has partnered with One Codex as the bioinformatics platform powering the Discrepancy
          Report analysis. You'll be redirected to One Codex automatically in 5 seconds.
        </p>
        <Checkbox
          inline={true}
          label="Don't show this notice again."
          checked={doNotAsk}
          onChange={() => setDoNotAsk((prevValue) => !prevValue)}
        />
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            className={TIMER_5S_WRAPPER_CLASSNAME}
            onClick={handleConfirm}
            intent={Intent.PRIMARY}
          >
            <Timer5s onTimeout={handleConfirm} />
            Continue to One Codex
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
